import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای شیفت‌های کاری (Shopfloor Shifts)

ماژول مدیریت شیفت در بخش `Shopfloor` به شما این امکان را می‌دهد تا زمان‌بندی‌های مختلف خطوط تولید و حضور اپراتورها را مدیریت کنید.

## معرفی بخش‌ها

<Alert variant="info">
این صفحه برای زمان‌بندی ساعات کاری و حضور اپراتورها طراحی شده است. برای تخصیص کاربران به شیفت‌ها باید ایستگاه کاری را از قبل انتخاب کرده باشید.
</Alert>

### ۱. ثبت شیفت جدید
برای ایجاد شیفت جدید، در بخش "افزودن شیفت جدید":
- **کد شیفت:** یک کد منحصر به فرد (مثلاً `SH-01`).
- **نام شیفت:** عنوان نمایشی شیفت (مثلاً `شیفت صبح`).
- **ساعت شروع و پایان:** زمان حضور و ترک پرسنل.

### ۲. لیست شیفت‌ها
شیفت‌های تعریف‌شده در جدول پایین صفحه نمایش داده می‌شوند. در نسخه‌های آتی قابلیت غیرفعال‌سازی موقت شیفت‌ها نیز در این جدول اضافه خواهد شد.

export default Layout;
